import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';

import { PageMasterModule } from './masterComponent/pagemaster.module';
import { LoginModule } from '../login/login.module';
import { DirettaPortaleModule } from '../diretta-portale/diretta-portale.module';

import { BaseWebApiService, DialogsService, NavigationService } from 'angular-library';
import { UserService } from './services/user.service';
import { DiretteService } from './services/dirette.service';
import { TimeInfoService } from './services/time-info.service';

@NgModule({
    imports: [
        HttpModule,
        LoginModule,
        PageMasterModule,
        DirettaPortaleModule
    ],
    exports: [
        FormsModule
    ],
    providers: [
        DialogsService,
        BaseWebApiService,
        NavigationService,
        UserService,
        DiretteService,
        TimeInfoService
    ]
})
export class CoreModule {
    constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error(
                'CoreModule is already loaded. Import it in the AppModule only');
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/core/core.module.ts